import { SheetClose, SheetHeader, SheetTitle } from '@e2n/ui';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function UpdateTerminKalenderSheetHeader() {
  const { t } = useTranslation();

  return (
    <SheetHeader className="flex flex-row items-center gap-2 bg-neutrals-200 p-4 space-y-0">
      <SheetClose>
        <FontAwesomeIcon
          className="text-primary-blue-500 cursor-pointer"
          icon={faArrowLeft}
          fixedWidth
        />
      </SheetClose>
      <SheetTitle className="text-sm text-neutrals-800">
        {t('domain.termine.kalender.form.kalenderBearbeiten')}
      </SheetTitle>
    </SheetHeader>
  );
}
